export default "__VITE_ASSET__e4d69b2c__"